import { Pipe, PipeTransform } from '@angular/core';

import { formatCrc } from '../utils/currency.util';

/**
 * Importe en colones para plantillas: `{{ total | crc }}` → `₡12.000`.
 *
 * Sustituye a `DecimalPipe` y `CurrencyPipe` en TODO importe. Esos dos dependen
 * del `LOCALE_ID` activo —que este repo no registra, así que caen a `en-US` y
 * pintan coma— y `CurrencyPipe` con `'CRC'` acaba en el CLDR, que hoy emite
 * espacio estrecho. Ver `shared/utils/currency.util.ts`.
 *
 * **El símbolo lo pone la pipe.** Al migrar hay que BORRAR el `₡` literal de la
 * plantilla: `₡{{ x | crc }}` da `₡₡1.234`. El signo menos de un desglose sí se
 * queda fuera (`-{{ x | crc }}`), porque es una resta, no el signo del número.
 *
 * Pura: `formatCrc` no tiene estado ni depende del entorno.
 */
@Pipe({
  name: 'crc',
  standalone: true,
  pure: true,
})
export class CrcPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    return formatCrc(value);
  }
}
